import React from 'react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-white pt-20">
      {/* Hero Section */}
      <section className="bg-black text-white py-20">
        <div className="max-w-[1920px] mx-auto px-6 lg:px-12">
          <h1 className="text-5xl lg:text-6xl font-bold tracking-tight mb-6">
            Allgemeine Geschäftsbedingungen
          </h1>
          <p className="text-xl text-white/80 max-w-2xl">
            für Mitgliedschaften der Positiv Fitness Wolnzach GmbH
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          {/* Einleitung */}
          <div className="mb-12">
            <p className="text-gray-700 leading-relaxed">
              <strong>Positiv Fitness Wolnzach GmbH</strong><br />
              Preysingstraße 64, 85283 Wolnzach
            </p>
          </div>

          {/* § 1 Geltungsbereich */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">§ 1 Geltungsbereich</h2>
            <p className="text-gray-700 leading-relaxed">
              Diese AGB gelten für alle Mitgliedschaften und Nutzungsvereinbarungen zwischen dem Studio 
              und dem Mitglied. Abweichende Bedingungen des Mitglieds werden nicht Vertragsbestandteil, 
              es sei denn, das Studio stimmt ihnen ausdrücklich zu.
            </p>
          </div>

          {/* § 2 Leistungen des Studios */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">§ 2 Leistungen des Studios</h2>
            <p className="text-gray-700 leading-relaxed">
              Der Leistungsumfang ergibt sich aus dem jeweils gewählten Tarif (z. B. Trainingsflächen, Geräte, 
              Kurse, Sauna, Zusatzleistungen). Öffnungszeiten, Kurspläne und Leistungsinhalte können aus 
              sachlichen Gründen (z. B. Wartung, Modernisierung, gesetzliche Vorgaben, Personal-/Sicherheitsgründe) 
              angepasst werden, sofern die Änderungen für das Mitglied zumutbar sind.
            </p>
          </div>

          {/* § 3 Pflichten des Mitglieds */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">§ 3 Pflichten des Mitglieds / Hausordnung</h2>
            <p className="text-gray-700 leading-relaxed">
              Das Mitglied hat die Hausordnung sowie Anweisungen des Personals zu beachten. Das Mitglied 
              bestätigt, sportgesund zu sein und Training eigenverantwortlich auszuüben. Bei 
              gesundheitlichen Einschränkungen wird empfohlen, vor Trainingsbeginn ärztlichen Rat einzuholen.
            </p>
          </div>

          {/* § 4 Vertragsschluss */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">§ 4 Vertragsschluss und Mitgliedskarte</h2>
            <p className="text-gray-700 leading-relaxed">
              Der Vertrag kommt durch Unterzeichnung im Studio oder durch Bestätigung im Rahmen eines 
              vom Studio genutzten Verwaltungssystems zustande. Das Mitglied erhält eine Zutritts-/Mitgliedskarte. 
              Bei Verlust kann eine Ersatzkarte gegen Gebühr ausgegeben werden.
            </p>
          </div>

          {/* § 5 Laufzeit */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">§ 5 Laufzeit, Verlängerung, Kündigung</h2>
            <p className="text-gray-700 leading-relaxed">
              Die Mitgliedschaft wird mit einer Erstlaufzeit von 1 Monat, 12 Monaten oder 24 Monaten 
              geschlossen. Nach Ablauf der Erstlaufzeit verlängert sich der Vertrag auf unbestimmte Zeit. 
              Nach der Erstlaufzeit kann der Vertrag von beiden Parteien jederzeit mit einer Frist von einem 
              Monat gekündigt werden.
            </p>
          </div>

          {/* § 6 Beiträge */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">§ 6 Beiträge, Fälligkeit, SEPA-Lastschrift</h2>
            <p className="text-gray-700 leading-relaxed">
              Die Mitgliedsbeiträge sind als laufende, regelmäßige Teilzahlungen geschuldet und werden im 
              vereinbarten Turnus per SEPA-Lastschrift eingezogen. Das Mitglied stellt sicher, dass das 
              angegebene Konto ausreichende Deckung aufweist. Rücklastschriftgebühren und bankübliche 
              Kosten, die das Mitglied zu vertreten hat, können dem Mitglied weiterbelastet werden.
            </p>
          </div>

          {/* § 7 Zahlungsverzug */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">§ 7 Zahlungsverzug</h2>
            <p className="text-gray-700 leading-relaxed">
              Gerät das Mitglied in Zahlungsverzug, ist das Studio berechtigt, offene Beiträge anzumahnen 
              und die gesetzlichen Verzugsfolgen geltend zu machen. Bei erheblichem Zahlungsverzug kann 
              das Studio den Zugang bis zur Begleichung offener Forderungen vorübergehend sperren.
            </p>
          </div>

          {/* § 8 Stilllegung */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">§ 8 Stilllegung (Ruhen)</h2>
            <p className="text-gray-700 leading-relaxed">
              Bei längerer Krankheit oder Schwangerschaft kann die Mitgliedschaft auf schriftlichen Antrag 
              und gegen geeigneten Nachweis für einen angemessenen Zeitraum ruhend gestellt werden. Die 
              Vertragslaufzeit verlängert sich um den Zeitraum des Ruhens, sofern nicht gesetzliche 
              Sonderregelungen entgegenstehen.
            </p>
          </div>

          {/* § 9 Haftung */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">§ 9 Haftung</h2>
            <p className="text-gray-700 leading-relaxed">
              Die Nutzung der Einrichtungen erfolgt grundsätzlich auf eigene Gefahr. Für Schäden aus der 
              Verletzung des Lebens, des Körpers oder der Gesundheit haftet das Studio nach den 
              gesetzlichen Vorschriften. Für sonstige Schäden haftet das Studio nur bei Vorsatz oder grober 
              Fahrlässigkeit; bei leichter Fahrlässigkeit nur bei Verletzung wesentlicher Vertragspflichten und 
              begrenzt auf den vertragstypischen, vorhersehbaren Schaden. Die Haftung nach dem 
              Produkthaftungsgesetz bleibt unberührt.
            </p>
          </div>

          {/* § 10 Datenschutz */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">§ 10 Datenschutz</h2>
            <p className="text-gray-700 leading-relaxed">
              Die Verarbeitung personenbezogener Daten erfolgt gemäß der jeweils aktuellen 
              Datenschutzerklärung des Studios.
            </p>
          </div>

          {/* § 11 Änderungen */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">§ 11 Änderungen der AGB</h2>
            <p className="text-gray-700 leading-relaxed">
              Änderungen dieser AGB werden dem Mitglied in Textform mitgeteilt. Sie gelten als genehmigt, 
              wenn das Mitglied nicht innerhalb einer angemessenen Frist widerspricht, sofern dies gesetzlich 
              zulässig ist. Auf das Widerspruchsrecht wird gesondert hingewiesen.
            </p>
          </div>

          {/* § 12 Schlussbestimmungen */}
          <div className="mb-12">
            <h2 className="text-2xl font-bold mb-4">§ 12 Schlussbestimmungen</h2>
            <p className="text-gray-700 leading-relaxed">
              Es gilt deutsches Recht. Sollten einzelne Bestimmungen unwirksam sein oder werden, bleibt die 
              Wirksamkeit der übrigen Bestimmungen unberührt.
            </p>
          </div>

          {/* Stand */}
          <div className="border-t pt-8 mt-12">
            <p className="text-gray-500 text-sm">
              Stand: Februar 2026
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;
